module.exports = __webpack_public_path__ + "static/media/telemedicine_photo.e038e693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telemedicine_photo.png
// module id = 316
// module chunks = 0